import client from "./client";

export const declineOffer = (sessionId: string, clientId: string) =>
  client.post(
    `/client/${clientId}/session/${sessionId}/offer/decline`,
    {},
    {
      headers: { session_id: sessionId },
    }
  );
